export default {
    lableText: {
        fontSize: "20px",
    },

    selectAllCBox: {
        margin: "10px 0 0 0"
    },

    calendarBox: {
        display: "flex",
        justifyContent: "space-between",
        margin: "10px 0 35px"
    },

    calendar: {
        width: "45%"
    },

    extensionContainer: {
        display: "flex",
        margin: "10px 0 35px",
        columnGap: "25px"
    },

    horizontalLine: {
        margin: "20px 0 20px"
    },

    checkboxContainer: {
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gridGap: "20px",
    }
}